function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.75rem; /* mt-3 */\n  padding: 0.75rem; /* p-3 */\n  border: 1px solid;\n  border-color: #e5e7eb; /* border-gray-200 */\n  border-radius: 0.75rem; /* rounded-xl */\n  cursor: pointer;\n  transition: background-color 0.2s;\n  \n  &:hover {\n    background-color: #f9fafb; /* hover:bg-gray-50 */\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem; /* mb-2 */\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  height: 1.25rem; /* h-5 */\n  width: 1.25rem; /* w-5 */\n  border-radius: 9999px; /* rounded-full */\n  overflow: hidden;\n  margin-right: 0.5rem; /* mr-2 */\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  font-weight: 500; /* font-medium */\n  font-size: 0.875rem; /* text-sm */\n  color: #111827; /* text-gray-900 */\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  height: 5rem; /* h-20 */\n  overflow: hidden;\n  border-radius: 0.375rem; /* rounded-md */\n  background-color: #f3f4f6; /* bg-gray-100 */\n  margin-top: 0.25rem; /* mt-1 */\n  position: relative;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
// 인용 콘텐츠 스타일
export var QuotedContentCard = styled.div(_templateObject());
export var AuthorContainer = styled.div(_templateObject1());
export var AuthorAvatar = styled.div(_templateObject2());
export var AuthorName = styled.span(_templateObject3());
export var MediaThumbnail = styled.div(_templateObject4());
